import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RatesRootState } from '../Redux/RatesStore';
import RateCardApi from './View/Apis/RateCardApi';
import ActionHelper from '../../Common/Actions/ActionHelper';

export type RateCardPageViewState = {
    rateCard: unknown | undefined;
};

const initialStateValue: RateCardPageViewState = {
    rateCard: undefined
};

const baseReducerName = "RateCardPageViewState";

const rateCardPageViewStateSlice = createSlice({
    name: baseReducerName,
    initialState: initialStateValue,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadRateCard.fulfilled, (state, action) => {
                state.rateCard = action.payload;
            }).addCase(loadRateCard.rejected, (state) => {
                state.rateCard = undefined;
            });
    }
});

const loadRateCard = createAsyncThunk(
    `${ baseReducerName }/loadRateCard`,
    async (rateCardId: string, thunkAPI) => {
        try {
            return await ActionHelper.executeRequest(() => RateCardApi.loadRateCard(rateCardId));
        } catch(error) {
            thunkAPI.rejectWithValue(error);
        }
    }
);

// reducer for the main store.
export default rateCardPageViewStateSlice.reducer;

// reducers
// export const {
// } = rateCardPageViewStateSlice.actions;

// selectors
export const selectRateCard = (state: RatesRootState) => state.rateCardPageView.rateCard;

// thunks
export {
    loadRateCard
};
